// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { TNewPatch, TPatch } from '~/misc/patch/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerPatchesModel extends ManagerResource {
  protected endpoint: string = 'patches/';

  update(
    patchId: number,
    payload: TNewPatch,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPatch> {
    return this.patch<TPatch>(`${patchId}`, payload, requestConfig);
  }

  destroy(patchId: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`${patchId}?1`, undefined, requestConfig);
  }
}
